export default __webpack_public_path__ + "static/media/slide-9.655bd941.jpeg";